import styles from "../basic_register/RegisterComponent.module.css";
import { useEffect, useRef, useState } from "react";
import Api from "../../../services/ApiService";
import Webcam from "react-webcam";
import { Button, Card, CardBody, Row, Col, FormCheck, Spinner, FormControl, FloatingLabel } from "react-bootstrap";
import { FaCamera, FaUpload } from "react-icons/fa";
import HoverBadge from "../../shared/HoverBadge";
import { MdCached, MdCameraswitch } from "react-icons/md";
import { BsCheckLg } from "react-icons/bs";

const UploadForm = ({data, setData, setStage, setApiError}) => {
    
    const API = new Api();
    
    const [showCamera, setShowCamera] = useState(false);
    const cameraRef = useRef(null);
    const [hasPermission, setHasPermission] = useState(false);
    const [hasTakenPhoto, setHasTakenPhoto] = useState(false);
    const [showcaseImage, setShowcaseImage] = useState("");
    const [uploadLaterCheck, setUploadLaterCheck] = useState(false);
    const [noUpload, setNoUpload] = useState(false);
    const [questionMissing, setQuestionMissing] = useState(false);
    const [video, setVideo] = useState({width: 1080, height: 1920});
    const [isSending, setIsSending] = useState(false);

    useEffect(() => {
        const checkPermission = async () => {
            try {
                const result = await navigator.permissions.query({ name: "camera"});
                if (result.state === "granted") {
                    setHasPermission(true);
                }

                // listen to permission change
                result.onchange = () => {
                    setHasPermission(result.state === "granted");
                };
            } catch (err) {
                // fallback
                try {
                    await navigator.mediaDevices.getUserMedia({ video: true});
                } catch {
                    setHasPermission(false);
                }
            }
        }

        checkPermission();
    }, []);


    useEffect(() => {
        if (data.hasQuestion === true && uploadLaterCheck === true) {
            setUploadLaterCheck(false);
        }
    }, [data.hasQuestion])

    const switchCameraHanlder = () => {
        let var_video = {};
        if (video.facingMode === "environment") {
            var_video = {
                width: 1080,
                height: 1920,
                facingMode: {exact: "environment"}
            };
            var_video.facingMode = "user";

        } else {
            var_video = {
                width: 1920,
                height: 1080,
                facingMode: { exact: "environment"}
            };
            var_video.facingMode = "environment";
        }
        setVideo(var_video);
    }

    const takePhotoHandler = () => {
        setShowcaseImage(cameraRef.current.getScreenshot());
        var testImage = new Image();
        testImage.src = cameraRef.current.getScreenshot();
        setHasTakenPhoto(true);
    }

    const deletePhotoHandler = () => {
        setShowcaseImage("");
        setHasTakenPhoto(false);
    }

    const photoApprovedHandler = () => {
        var fileName = "";
        for (let i = 1; i < 21; i++) {
            fileName = `Bild-${i}`;
            var index = data.uploads.findIndex(i => i.file_name === fileName);
            if (index === -1) break;
        }
        setData(prev => ({...prev,
            uploads: [...prev.uploads, {file_name: fileName, file: showcaseImage.split(",")[1]}]
        }));
        setShowcaseImage("");
        setHasTakenPhoto(false);
        setShowCamera(false);
    }

    const selectLocalFile = (file) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            var tempList = data.uploads;
            var index = tempList.findIndex(i => i.file_name === file.name);
            if (index === -1) tempList.push({file_name: file.name, file: reader.result.split(",")[1]});
            setData(prev => ({...prev, uploads: tempList}));
        }
    }

    const removeFileFromUploads = (fileName) => {
        var tempList = data.uploads.filter(file => file.file_name !== fileName);
        setData(tempList);
    }

    const sendData = () => {
        setIsSending(true);
        setNoUpload(false);
        setQuestionMissing(false);
        if (uploadLaterCheck) {
            return uploadMissing();
        }

        if (data.hasQuestion !== undefined && data.hasQuestion === true) {
            if (data.question === undefined || data.question === "" || data.question.length < 4) {
                if (data.uploads === undefined || data.uploads.length === 0) {
                    setNoUpload(true);
                }
                    setIsSending(false);
                    return setQuestionMissing(true);
            }
        } else {
            if (data.uploads === undefined || data.uploads.length === 0) {
                setIsSending(false);
                return setNoUpload(true);
            }
        }


        var ticketData = {
            company_type: data.company_type,
            x_is_house_management: data.x_is_house_management,
            case: data.case,
            companyKw: data.companyKw,
            contactPerson: data.contactPerson,
            name: data.name + ` ${data.lastName}`,
            email: data.email,
            phone_country: "+43",
            vorwahl: "",
            phone: `${data.phone_country} ${data.vorwahl} ${data.phone}`,
            comment: data.comment,
            situation: data.situation,
            uploads: data.uploads,
            country_id: data.country_id,
            state_id: data.state_id,
            hasQuestion: data.hasQuestion,
            question: data.question,
        }
        if (data.upload_later !== undefined && data.upload_later !== "") {
            ticketData.upload_later = data.upload_later
        }
        API.angebot_einholen(ticketData)
            .then(() => {
                setStage("ticket_done");
            })
            .catch(err => {
                return;
            })
            .finally(() => {
                setIsSending(false);
            })
    }

    const uploadMissing = () => {
        setIsSending(true);
        var ticketData = {
            company_type: data.company_type,
            x_is_house_management: data.x_is_house_management,
            case: data.case,
            companyKw: data.companyKw,
            contactPerson: data.contactPerson,
            name: data.name,
            lastName: data.lastName,
            email: data.email,
            phone_country: "+43",
            vorwahl: "",
            phone: `${data.phone_country} ${data.vorwahl} ${data.phone}`,
            comment: data.comment,
            situation: data.situation,
        }
        API.register_missing_document(ticketData)
            .then(() => {
                setStage("upload_missing");
            })
            .catch(err => {
                if (err.response.data.detail !== undefined) {
                    setApiError(err.response.data.detail);
                } else {
                    setApiError("Unbekannter Fehler")
                }
                return
            })
            .finally(() => {
                setIsSending(false);
            });
    }
    
    return (
        <Card className={styles.shadowcard}>
            <CardBody>
                <div hidden={showCamera}>
                    <p className={styles.formdescription}>
                        Wir möchten Ihnen ein Angebot legen. Bitte laden Sie 
                        hier Ihre aktuelle Strom-, Gas- oder PV-Abrechnung(en) 
                        als Datei hoch oder fotografieren Sie diese. WICHTIG: 
                        Stellen Sie sicher, dass Sie <b>ALLE</b> Seiten der 
                        jeweiligen Abrechnung erfassen!
                    </p>

                    <div 
                        className="d-flex justify-content-center mt-4 mb-4" 
                        style={noUpload ? {border: "1px solid red"}: null}
                    >
                        <input type="file" name="attachment" id="attachment" hidden onChange={e => selectLocalFile(e.target.files[0])} />
                        <Button 
                            hidden={uploadLaterCheck}
                            style={{marginRight: 50}} 
                            variant="energo"
                            onClick={() => document.getElementById('attachment').click()}
                        >
                            <FaUpload size={30}/>
                        </Button>
                        <Button 
                            hidden={uploadLaterCheck}
                            variant="energo"
                            onClick={() => setShowCamera(!showCamera)}
                        >
                            <FaCamera size={30}/>
                        </Button>
                    </div>

                    <FormCheck
                        className={styles.formcheckbox}
                        type="checkbox"
                        label="Ich habe Fragen und/oder Anmerkungen"
                        value={data.hasQuestion}
                        onChange={e => setData(prev => ({...prev, hasQuestion: e.target.checked}))}
                    />

                    {data.hasQuestion === true &&
                        <FloatingLabel label="Frage und/oder Anmerkung">
                            <FormControl
                                
                                as={"textarea"}
                                style={{height: 100}}
                                value={data.question}
                                onChange={e => setData(prev => ({...prev, question: e.target.value}))}
                                isValid={data.question && data.question.length > 3}
                                isInvalid={questionMissing}
                            />
                        </FloatingLabel>
                    }

                    <FormCheck
                        hidden={data.upload_later !== undefined}
                        className={styles.formcheckbox}
                        type="checkbox"
                        label="Ich werde meine Jahresabrechnung später übermitteln. Bitte erinnern Sie mich per E-Mail daran."
                        checked={uploadLaterCheck}
                        onChange={e => setUploadLaterCheck(e.target.checked)}
                    />

                    {data.uploads && data.uploads.length > 0 &&
                        <Row className="mt-3">
                            <Col>
                                {data.uploads.map(file => (
                                    <HoverBadge
                                        key={`badge-${file.file_name}`}
                                        id={file.file_name}
                                        desc={file.file_name}
                                        remove={() => removeFileFromUploads(file.file_name)}
                                    />
                                ))}
                            </Col>
                        </Row>
                    }

                    <Row className="mt-3">
                        <Col className="text-end">
                            <Button 
                                className={styles.nextbtn} 
                                variant="energo" 
                                onClick={() => sendData()}
                                disabled={isSending}
                            >
                                {isSending? 
                                    <Spinner animation="border" /> :
                                    uploadLaterCheck === true ?
                                        "Erinnerung setzen": "Absenden"
                                }
                            </Button>
                        </Col>
                    </Row>
                </div>
                {showCamera &&
                    <>
                        <Row>
                            <Col>
                                <div className="wrapper" hidden={hasTakenPhoto}>
                                    <Webcam
                                        audio={false}
                                        ref={cameraRef}
                                        screenshotFormat="image/jpeg"
                                        screenshotQuality={1}
                                        forceScreenshotSourceSize={true}
                                        width={"100%"}
                                        height={"400px"}
                                        videoConstraints={video}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row className="mt-3" hidden={showcaseImage === ""}>
                            <Col className="text-center">
                                <img src={showcaseImage} alt="" style={{height: 400}} />
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-center mt-3" hidden={!hasPermission}>
                            <Button
                                hidden={hasTakenPhoto}
                                onClick={() => switchCameraHanlder()}
                                variant="warning"
                                size="lg"
                                style={{marginRight: 20}}
                            >
                                <MdCameraswitch />
                            </Button>
                            <Button
                                hidden={hasTakenPhoto}
                                size="lg"
                                variant="energo"
                                onClick={() => takePhotoHandler()}
                            >
                                <FaCamera />
                            </Button>
                            <Button
                                variant="danger"
                                hidden={!hasTakenPhoto}
                                onClick={() => deletePhotoHandler()}
                                style={{marginRight: 20}}
                            >
                                <MdCached /> Erneut versuchen
                            </Button>
                            <Button
                                variant="energo"
                                hidden={!hasTakenPhoto}
                                onClick={() => photoApprovedHandler()}
                            >
                                <BsCheckLg /> Ich bin zufrieden
                            </Button>
                        </div>
                        <div className="text-center text-danger" hidden={hasPermission}>
                            <p>Bitte erlaube den Kamerazugriff, um fortzufahren.</p>
                        </div>
                    </>
                }
            </CardBody>
        </Card>
    )
}
export default UploadForm;